<span class="st-rundown-choose-columns__header">{{ languageSettings.PSTWebRundownChooseColumns }}</span>
<st-columns-selector
    [columnsFieldDefs]="columnsFieldDefs()"
    [pageNumEditable]="pageNumEditable()"
    [hiddenColumnsInput]="hiddenColumns"
    [fixedColumnsInput]="fixedColumns()"
    [selectedColumnsInput]="selectedColumns()"
    (changed)="onColumnSelectionChanged($event)" />
<div class="st-rundown-choose-columns__footer">
    <div class="st-rundown-choose-columns__footer__buttons">
        <button
            mat-button
            (click)="close()">
            {{ languageSettings.PSTWebCancelButtonLabel }}
        </button>
        <button
            class="st-rundown-choose-columns__footer__buttons__update"
            mat-button
            [disabled]="disableUpdate()"
            (click)="update()">
            {{ languageSettings.PSTWebSaveButtonLabel }}
        </button>
    </div>
</div>
